import { DefaultService } from '@/services/DefaultService';

export default class PedidoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(filtro, column, order, page = 0, limit = 20, contagem, params) {
        return this._http.post(encodeURI(`${this._env}/vendas/pedido.json?page=${page}&limit=${limit}&order=${order}&column=${column}&contagem=${contagem}&param=${params}`), filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getItems(id, column, order, page = 0, limit = 20) {
        return this._http.get(`${this._env}/vendas/pedido/${id}/items.json?page=${page}&limit=${limit}&order=${order}&column=${column}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getContagem(id, column, order, page = 0, limit = 20) {
        return this._http.get(`${this._env}/vendas/pedido/${id}/count.json?page=${page}&limit=${limit}&order=${order}&column=${column}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getChecks(id, column, order, page = 0, limit = 20) {
        return this._http.get(`${this._env}/vendas/pedido/${id}/checks.json?page=${page}&limit=${limit}&order=${order}&column=${column}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getSignature(id) {
        return this._http.get(`${this._env}/vendas/pedido/${id}/signature.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/vendas/pedido/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findPedidoRetorno(id) {
        return this._http.get(`${this._env}/vendas/pedido/return/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getItemsPedidoRetorno(idPedidoRetorno, idPedido, column, order, page = 0, limit = 20) {
        return this._http.get(`${this._env}/vendas/pedido/return/items.json?idPedidoRetorno=${idPedidoRetorno}&idPedido=${idPedido}&page=${page}&limit=${limit}&order=${order}&column=${column}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getOrigensPedidoCombo() {
        return this._http.get(`${this._env}/vendas/pedido/getcombo/origens.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getStatusPedidoCombo() {
        return this._http.get(`${this._env}/vendas/pedido/getcombo/status.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getStatusPedidoComboEdit(idVenPedidoSituacao, autorizacaoSituacao, withStatusWf) {
        return this._http.get(`${this._env}/vendas/pedido/getcombo/edit/status/${idVenPedidoSituacao}.json?autorizacao-situacao=${autorizacaoSituacao}&with-status-wf=${withStatusWf}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    save(pedido) {
        return this._http.post(`${this._env}/pedido`, pedido, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    update (pedido) {
        return this._http.post(`${this._env}/liberacao/pedido`, pedido, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getPagamentoByPedido(uuidPedido, page = 0, limit = 15) {
        return this._http.get(`${this._env}/cielo/status/pagamento.json?page=${page}&limit=${limit}&uuidPedido=${uuidPedido}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadAnexosPedido(idPedido, idPedidoErp, page, limit, column, order) {
        return this._http.get(`${this._env}/pedido/${idPedido}/attachment.json?page=${page}&idpedidoerp=${idPedidoErp}&limit=${limit}&order=${order}&column=${column}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}